import { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";

import {
  NumbersCounter,
  Checkbox as RadioBtn
} from "@unified-checkout/design-system";

import {
  useCheckoutCustomizationStore
} from "@app/dashboard/store/checkout-customization";
import type {
  ICheckoutCustomizationData
} from "@app/dashboard/types/innerLayout/checkout_customization";
import {
  AUTO_REDIRECT,
  PAYMENT_CONFIRMATION_DEFAULT_SECS,
  PAYMENT_CONFIRMATION_MAX_SECS,
  PAYMENT_CONFIRMATION_MIN_SECS
} from "../../../../utils";
import { Title } from "../../../../components/Title";
import styles from "./redirection-experience.module.scss";

type TOption = { key: ICheckoutCustomizationData['post_payment']['mode'], label: string; };

export const RedirectionExperience = () => {
  const { t } = useTranslation();
  const {
    isFetched,
    isDataReset,
    customizationData,
    setCustomizationData
  } = useCheckoutCustomizationStore();

  const { post_payment } = customizationData;
  const { mode, auto_redirect } = post_payment;

  const redirectionOptions: TOption[] = t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.redirectionExp.confirmationOptions', { returnObjects: true });

  const [selectedOption, setSelectedOption] = useState(redirectionOptions[0]);
  const [counter, setCounter] = useState(PAYMENT_CONFIRMATION_DEFAULT_SECS);

  useEffect(() => {
    if (isFetched) {
      setSelectedOption(redirectionOptions.find(opt => opt.key === mode) || redirectionOptions[0]);
      setCounter(auto_redirect);
    }
  }, [isFetched, isDataReset]);

  useEffect(() => {
    setCustomizationData(prevData => ({
      ...prevData,
      post_payment: {
        ...prevData.post_payment,
        auto_redirect: counter
      }
    }));
  }, [counter]);


  const handleOptionsChange = (option: TOption) => {
    setSelectedOption(option);

    setCustomizationData(prevData => ({
      ...prevData,
      post_payment: {
        ...prevData.post_payment,
        mode: option.key
      }
    }));
  };

  const handleSecsChange = (count: number) => {
    setCounter(count);
  };

  return (
    <div className={styles["redirection-exp"]}>
      <Title
        label={t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.redirectionExp.label')}
        hint={t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.redirectionExp.hint')}
      />
      {
        redirectionOptions.map((option, index) =>
          <Fragment key={`redirection-exp-option-${index}`}>
            <RadioBtn
              type="radio"
              id={`redirection-exp-radio-btn-${index}`}
              hintText={option.label}
              selected={selectedOption.key === option.key}
              onClickHandler={() => handleOptionsChange(option)}
            />

            {
              (
                selectedOption.key === AUTO_REDIRECT &&
                index === 0
              ) &&
              <div className={styles["redirection-exp__secs-counter"]}>

                <div className={styles["redirection-exp__secs-counter__label"]}>
                  {t('innerLayout.checkoutCustomizationPage.tabs.postPayment.sections.redirectionExp.selectNoOfSecs')}
                </div>
                <NumbersCounter
                  key={`redirection-exp-secs-counter`}
                  name="redirection-exp-secs-counter"
                  min={PAYMENT_CONFIRMATION_MIN_SECS}
                  max={PAYMENT_CONFIRMATION_MAX_SECS}
                  current={counter}
                  onChangeHandler={handleSecsChange}
                />
              </div>
            }
          </Fragment>
        )
      }
    </div>
  )
}
